import { render, staticRenderFns } from "./text.vue?vue&type=template&id=6e615f42"
import script from "./text.vue?vue&type=script&lang=js"
export * from "./text.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e615f42')) {
      api.createRecord('6e615f42', component.options)
    } else {
      api.reload('6e615f42', component.options)
    }
    module.hot.accept("./text.vue?vue&type=template&id=6e615f42", function () {
      api.rerender('6e615f42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/postCreator/components/storyTab/storyMaker/stiker/text.vue"
export default component.exports